import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "store/store";
import { hideLoading, showLoading } from "./loadingSlice";
import { axiosInstance } from "config/axiosConfig";
import { API_ENDPOINTS } from "config/apiConfig";
import { UserTypeEnum } from "common/enums/UserType.enum";

interface RegisterState {
  registerSellerData: any;
  registerBuyerData: any;
  verifyData: any;
  errorSeller: any;
  errorBuyer: any;
  errorVerify: any;
}

const initialState: RegisterState = {
  registerSellerData: null,
  registerBuyerData: null,
  verifyData: null,
  errorSeller: null,
  errorBuyer: null,
  errorVerify: null,
};

export const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    sendMailSellerSuccess: (state, action: PayloadAction<any>) => {
      state.registerSellerData = action.payload;
      state.errorSeller = null;
    },
    sendMailSellerFailure: (state, action: PayloadAction<any>) => {
      state.errorSeller = action.payload;
      state.registerSellerData = null;
    },
    sendMailBuyerSuccess: (state, action: PayloadAction<any>) => {
      state.registerBuyerData = action.payload;
      state.errorBuyer = null;
    },
    sendMailBuyerFailure: (state, action: PayloadAction<any>) => {
      state.errorBuyer = action.payload;
      state.registerBuyerData = null;
    },
    verifySuccess: (state, action: PayloadAction<any>) => {
      state.verifyData = action.payload;
      state.errorVerify = null;
    },
    verifyFailure: (state, action: PayloadAction<any>) => {
      state.errorVerify = action.payload;
      state.verifyData = null;
    },
    cleanDataRegister: (state) => {
      state.registerSellerData = null;
      state.registerBuyerData = null;
      state.errorBuyer = null;
      state.errorSeller = null;
      state.verifyData = null;
      state.errorVerify = null;
    },
  },
});

export const {
  sendMailSellerSuccess,
  sendMailSellerFailure,
  sendMailBuyerSuccess,
  sendMailBuyerFailure,
  cleanDataRegister,
  verifySuccess,
  verifyFailure,
} = registerSlice.actions;

export const fetchSendMailRegisterSeller =
  (email: string): AppThunk =>
  async (dispatch) => {
    dispatch(showLoading());
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.SELLER_REGISTER, {
        email: email,
        type: UserTypeEnum.COMPANY_SELLER,
      });
      dispatch(sendMailSellerSuccess(response.data));
    } catch (error: any) {
      dispatch(sendMailSellerFailure(error));
    } finally {
      dispatch(hideLoading());
    }
  };

export const fetchSendMailRegisterBuyer =
  (email: string): AppThunk =>
  async (dispatch) => {
    dispatch(showLoading());
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.BUYER_REGISTER, {
        email: email,
        type: UserTypeEnum.COMPANY_BUYER,
      });
      dispatch(sendMailBuyerSuccess(response.data));
    } catch (error: any) {
      dispatch(sendMailBuyerFailure(error));
    } finally {
      dispatch(hideLoading());
    }
  };

export const fetchCheckToken =
  (token: string): AppThunk =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.CHECK_TOKEN + "/" + token,
      );
      dispatch(verifySuccess(response.data));
    } catch (error: any) {
      dispatch(verifyFailure(error.response.data));
    }
  };

export default registerSlice.reducer;
